var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import Icon from '@datashop/icon';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var Wrapper = withProps(styled.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  pointer-events:", "\n  opacity:", "\n"], ["\n  display: flex;\n  align-items: center;\n  pointer-events:", "\n  opacity:", "\n"])), function (props) { return (props.disabled ? 'none' : 'auto'); }, function (props) { return (props.disabled ? '0.3' : '1'); });
var RadioInput = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 1; // To render (to make it clickable) input box with 0 opacity above styled icon\n  top: 0;\n  left: 0;\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  z-index: 1; // To render (to make it clickable) input box with 0 opacity above styled icon\n  top: 0;\n  left: 0;\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  cursor: pointer;\n"])));
var IconWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  width: 14px;\n  height: 14px;\n  margin-right: 4px;\n  color: ", ";\n"], ["\n  position: relative;\n  width: 14px;\n  height: 14px;\n  margin-right: 4px;\n  color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme, checked = _a.checked;
    return checked
        ? theme.datashop.palette.blue.main
        : theme.datashop.palette.black.main;
});
var Label = styled.label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  line-height: 1;\n"], ["\n  cursor: pointer;\n  line-height: 1;\n"])));
export var Radio = function (_a) {
    var label = _a.label, id = _a.id, checked = _a.checked, disabled = _a.disabled, style = _a.style, className = _a.className, props = __rest(_a, ["label", "id", "checked", "disabled", "style", "className"]);
    return (React.createElement(Wrapper, { disabled: disabled },
        React.createElement(IconWrapper, { checked: checked },
            React.createElement(RadioInput, __assign({ checked: checked, id: id }, props, { type: "radio" })),
            React.createElement(Icon, { name: checked ? 'radio_button_checked' : 'radio_button_unchecked' })),
        React.createElement(Label, { style: style, className: className, htmlFor: id }, label)));
};
Radio.defaultProps = {};
export default Radio;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Radio.js.map